import { render } from "./GaugesDashboard.vue?vue&type=template&id=3b840a22&scoped=true"
import script from "./GaugesDashboard.vue?vue&type=script&lang=js"
export * from "./GaugesDashboard.vue?vue&type=script&lang=js"

import "./GaugesDashboard.vue?vue&type=style&index=0&id=3b840a22&scoped=true&lang=css"

import exportComponent from "/var/www/potabilis/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b840a22"]])

export default __exports__